import React from "react";
import ReactDOM from "react-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import * as serviceworker from './serviceWorker'

import App from "./App";
import { SYSTEM_VERSION } from "./version";

// Inicializa a versão no localStorage caso ainda não esteja definida
if (!localStorage.getItem("system_version")) {
	localStorage.setItem("system_version", SYSTEM_VERSION);
}

// Previne que erros 401 (não autorizados/sessão expirada) disparem a tela vermelha de erro (unhandled rejection) do React
window.addEventListener("unhandledrejection", (event) => {
	if (event.reason?.isAuthError) {
		event.preventDefault();
		event.stopImmediatePropagation();
	}
}, true);

ReactDOM.render(
	<CssBaseline>
		<App />
	</CssBaseline>,
	document.getElementById("root"),
	() => {
		if (typeof window.finishProgress === "function") {
			window.finishProgress();
		}
	}
);

serviceworker.register()